var product_images_mapper = {
    '4365499367490':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '4400164339778':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },

    '4400164536386':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',

       
        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '4400164765762':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '4400164995138':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '4400165257282':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',

       
        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '4400165552194':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '4400165748802':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '8883409453313':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '4431804203074':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '4431804792898':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '6066307924149':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '6081956479157':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '6082373222581':{
        'Round+White Gold 1': 'Round+1.00 ct $3,600 to $5,999k+White Gold 1',
        'Round+White Gold 2':'Round+1.00 ct $3,600 to $5,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+1.00 ct $3,600 to $5,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+1.00 ct $3,600 to $5,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+1.00 ct $3,600 to $5,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+1.00 ct $3,600 to $5,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',
      
        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    }

// duplicate products
  ,
    '8055893065985':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '8063385043201':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Emerald+White Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Emerald+White Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Emerald+Yellow Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Emerald+Yellow Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Emerald+Rose Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Emerald+Rose Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '8063588172033':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Emerald+White Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Emerald+White Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Emerald+Yellow Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Emerald+Yellow Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Emerald+Rose Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Emerald+Rose Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },  
    '8067577184513':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Emerald+White Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Emerald+White Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Emerald+Yellow Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Emerald+Yellow Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Emerald+Rose Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Emerald+Rose Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '8067618603265':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Emerald+White Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Emerald+White Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Emerald+Yellow Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Emerald+Yellow Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Emerald+Rose Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Emerald+Rose Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '8336857432321':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Emerald+White Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Emerald+White Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Emerald+Yellow Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Emerald+Yellow Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Emerald+Rose Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Emerald+Rose Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',
        
        'Marquise+White Gold 1': 'Marquise+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Marquise+White Gold 2':'Marquise+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Marquise+Yellow Gold 1': 'Marquise+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Marquise+Yellow Gold 2':'Marquise+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Marquise+Rose Gold 1': 'Marquise+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Marquise+Rose Gold 2':'Marquise+0.50 ct $1,010 to $2,299k+Rose Gold 2',
        
    },
    '8338080465153':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Emerald+White Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Emerald+White Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Emerald+Yellow Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Emerald+Yellow Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Emerald+Rose Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Emerald+Rose Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    }
    
  };

   // for the size
    $(document).on('change',"select[name='properties[RING SIZE]']",function(){
      var optionval=$("select[name='properties[RING SIZE]'] option:selected").val();
      var originprice=$(".origin_price").html();
      originprice=$.trim(originprice);
      var productfinalprice='';  var lastWord = optionval.split(" ");
      lastWord=lastWord[1];var price=lastWord;
      if(lastWord != undefined){
       lastWord=lastWord.substring(1, lastWord.length);
       lastWord=lastWord.replace(/,/g , '');
        var product_price=$(".custom_price").attr('data-price');
        product_price=product_price.substring(1, product_price.length);
        var productdiamond=$(".custom_price").attr('data-value');
        $(".custom_price").attr("data-size",price);
        if(productdiamond != ''){
          productdiamond=productdiamond.substring(1, productdiamond.length);
          productdiamond=productdiamond.replace(/,/g , '');
          productfinalprice=parseFloat(product_price)+parseFloat(productdiamond)+parseFloat(lastWord)+parseFloat(originprice);
          productfinalprice=productfinalprice.toFixed(2);
          $("#product_cutom_price").val("$"+productfinalprice);
          $(".custom_price").html("$"+productfinalprice);
        }else{
           productfinalprice=parseFloat(product_price)+parseFloat(lastWord)+parseFloat(originprice);
           productfinalprice=productfinalprice.toFixed(2);
           $(".custom_price").html("$"+productfinalprice);
          $("#product_cutom_price").val("$"+productfinalprice);
        } 
      }
     });
     // for the size
    $(document).on('change',"select[name='properties[RING SIZE 1]']",function(){
      var optionval=$("select[name='properties[RING SIZE 1]'] option:selected").val();
      var originprice=$(".origin_price").html();
      originprice=$.trim(originprice);    var productfinalprice=''; 
      var lastWord = optionval.split(" "); lastWord=lastWord[1]; var price=lastWord;
      
      if(lastWord != undefined) {
       lastWord=lastWord.substring(1, lastWord.length);  lastWord=lastWord.replace(/,/g , '');
        var product_price=$(".custom_price").attr('data-price');
        product_price=product_price.substring(1, product_price.length);
        var productdiamond=$(".custom_price").attr('data-value');
        $(".custom_price").attr("data-size",price);
        if(productdiamond != '') {
          productdiamond=productdiamond.substring(1, productdiamond.length);
          productdiamond=productdiamond.replace(/,/g , ''); 
          productfinalprice=parseFloat(product_price)+parseFloat(productdiamond)+parseFloat(lastWord)+parseFloat(originprice);
          productfinalprice=productfinalprice.toFixed(2);
          $("#product_cutom_price").val("$"+productfinalprice);
          $(".custom_price").html("$"+productfinalprice);
        }  else  {
           productfinalprice=parseFloat(product_price)+parseFloat(lastWord)+parseFloat(originprice);
           productfinalprice=productfinalprice.toFixed(2);
           $(".custom_price").html("$"+productfinalprice);
          $("#product_cutom_price").val("$"+productfinalprice); 
        } 
      }
     });
    
    $(document).on('click','.engarvingtext_imge',function(){
      var fontname=$(this).attr("data-value");
      $("#engraving-font-bg").val(fontname);
      if(fontname=='classic') {
        fontname='bold 20pt classic';
      }else {
          fontname='italic bold 20pt classic';
      }
      var image=$(this).find('.engarvingimage').attr("src");
      $('.engwrapimg').attr('src',image);
      if($(".engarvingtext_imge").hasClass('active_eng'))
      {
       $(".engarvingtext_imge").removeClass('active_eng');
       $(this).addClass("active_eng");
      }
      var getvalue =($("input[name='properties[ENGRAVINGS]']").length >0) ? $("input[name='properties[ENGRAVINGS]']").val(diamondshap) : $("input[name='properties[ENGRAVINGS 1]']").val()  ;
    });

  function addCaret(e){
      $("span.bold_option_value ").attr('id','');
      $("span.bold_option_swatch ").attr('id','');
   		$("#selected_caret").removeAttr("id");
    $("#selected_caret_options").removeAttr("id"); 
      var selected_option = $(e).attr('data-option-val');
      if($("input[name='properties[Carat weight options]']").length > 0 ){
    		var inputname = "input[name='properties[Carat weight options]']";
      }else{
        var inputname = "input[name='properties[Carat weight options Mined]']";
      }
    $(inputname).parent().parent().parent().parent().parent().attr('id','selected_caret');
      $('#selected_caret .bold_option_value:nth-child('+selected_option+')').attr('id','selected_caret_options');
     $("#selected_caret_options .bold_option_value_element").trigger('click');
  }

   $(document).on('DOMNodeInserted', function(e) {
    if ( $(e.target).hasClass('bold_error_message') ) {
      $(".carat_weight_error").text($(".bold_error_message").first().text());
      $(".carat_weight_error").show();$(e.target).hide();
      var topLink = $('.product-details').offset().top;
      var clickedLink = $('.carat_weight_error').offset().top; 
      toScroll = clickedLink - topLink + 100;
      $([document.documentElement, document.body]).animate({ scrollTop: toScroll }, 1000);
    }
  });
  
  

  $(".product-gallery--media-thumbnail").on('click',function(e){
    if($(this).hasClass('videodata')){
      	e.preventDefault();
      	$(".product-gallery--viewer").hide();
      	$(".productvdeiogallery").show();
      $(".product-gallery--media-thumbnail").attr('data-gallery-selected',false);
      $(".videodata").attr('data-gallery-selected',true);
      e.stopPropagation();
    }else{
      $(".product-gallery--viewer").show();
      	$(".productvdeiogallery").hide();
      $(".videodata").attr('data-gallery-selected',false);
    }
  });
// Function to handle changes
function handleMutation(mutations) {
  mutations.forEach(mutation => {
    if (mutation.type === 'childList' || mutation.type === 'subtree') {
      // Update the text content
      const newText = $(".bold_option_total").children('div').children('span').text();
      $("span.money.bold_price_cs").text(newText);
    }
  });
}

// Function to start observing
function startObserving() {
  // Create an instance of MutationObserver and pass the callback function
  const observer = new MutationObserver(handleMutation);
  const config = {
    childList: true,    // Observe direct children
    subtree: true       // Observe all descendants (not just direct children)
  };
  const targetNode = document.querySelector('.bold_option_total');
  if (targetNode) {
    observer.observe(targetNode, config);
  }
}
$(document).ready(function(){setTimeout(function(){startObserving();},1000)});
  $(document).on('mouseenter','.gallery-navigation--scroller button', function() {
        $(this).trigger('click');
  });
  function detectmobile() { 
    if (navigator.userAgent.match(/Android/i) 
        || navigator.userAgent.match(/webOS/i) 
        || navigator.userAgent.match(/iPhone/i)  
        || navigator.userAgent.match(/iPad/i)  
        || navigator.userAgent.match(/iPod/i) 
        || navigator.userAgent.match(/BlackBerry/i) 
        || navigator.userAgent.match(/Windows Phone/i)) { 
      return true; 
    } else { 
      return false; 
    } 
  }
  function getProductImages(product_id){
 	var spreadsheetID = "1j9JQAwAoc2B4H-s0RHJEvyb7jvFM2840SOFFbFg-jIo";
   // https://sheets.googleapis.com/v4/spreadsheets/1j9JQAwAoc2B4H-s0RHJEvyb7jvFM2840SOFFbFg-jIo/?alt=json&key=AIzaSyA23vTImx6TIgMVysUSpfvfY0H_x33Wp0A
 	var url = `https://sheets.googleapis.com/v4/spreadsheets/1j9JQAwAoc2B4H-s0RHJEvyb7jvFM2840SOFFbFg-jIo/values/${product_id}?alt=json&key=AIzaSyA85Tm9_dG1EVUI2hBuCGta4ED9wHk9Mno`;
	// make JSON call to Google Data API
	$.getJSON(url, function(data) {
  		var html = '';
        var entry = data.values ;//data.feed.entry; 
      j = 1;
      for (var i = 1; i < entry.length; i++) {
         if(entry[i][0] == product_id){
          html += '<div class="product_ring_wrap customizedata-'+ j+'">';
          html +='<span class="ring_title">'+ entry[i][1] + '</span>';
          html += '<span class="ring_image">'+ entry[i][2] + '</span>';
          html +='</div>';
          j++;
        }
       }
      $('.product_ring_customize').html(html); 
    });
  }
  function displayPrice(origin,carat,array1,array2,array3, array4 = [])
  { 
     var arrayval='';
    var j=1;
    if(origin == "Lab Created")
    {
      if(carat == "0.50" || carat.trim() == "1.00")
      {
        arrayval=array1;
      }
      else if(carat == "0.70" || carat == "1.50")
      {
        arrayval=array2;
      }else if(carat == "2.50")
      {
        arrayval=array4;
      }else if(carat == "3.00")
      {
        arrayval=array5;
      }else if(carat == "4.00")
      {
        arrayval=array6;
      }
      else
      { 
        arrayval=array3;
  
      }
    }else{
      if(carat == "0.50")
      { 
        arrayval=array1;
      }
      else if(carat == "0.70")
      {
        arrayval=array2;
      }
      else
      {
        arrayval=array3;
  
      }
    }

    for(i=0;i<arrayval.length;i++)
    {
      if(i<=4)
      {

        $(".pricename"+j).html(arrayval[i]);
        j++;
      }

    }
    
    if(origin == "Lab Created")
    {
       $(".colorname3").html("E-F");
       $(".colorname5").html("E-F");
       $(".clarityname1").html("SI1");
       $(".clarityname2").html("SI1");
       $(".clarityname3").html("SI1");
       $(".clarityname4").html("VS2");
       $(".clarityname5").html("VS1");
    }
    else
    {
       $(".colorname3").html("F-G");
       $(".colorname5").html("G-H");
       $(".clarityname1").html("I1");
       $(".clarityname2").html("SI2");
       $(".clarityname3").html("I1");
       $(".clarityname4").html("SI2");
       $(".clarityname5").html("SI1");
    }
    
  }